import { Privacy } from "#/pages";

const PrivacyView = () => {
    return (
        <Privacy></Privacy>
    );
}

export default PrivacyView;